export default __webpack_public_path__ + "static/media/use_action_back_hk.5284b17c.png";